import React, {useEffect, useState} from "react";
import styles from "./NavbarDropdown.module.css"

function NavbarDropdown (props) {

  const [lista,setLista] = useState([])

  useEffect(()=>{
      renderElementi()
  },[props.dropDownList])

  function renderElementi(){
    let nuovaLista = []
    props.dropDownList.forEach((element,index) => {
      let elementoLista = (
          <a key={index} href={element.href} onClick={() => element.onClick()} style={{color: "white"}}>
              <li
                  className={[styles.dropdownItemCustom, styles.spanCustom]
                      .join(" ")
                      .concat(" dropdown-item")}
              >
                  <span className={styles.listItem}>{element.label}</span>
              </li>
          </a>
      )
        nuovaLista.push(elementoLista)
    })
    setLista(nuovaLista);
  }

  return (
      <div id={"logoutMenu"} className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <div className="link-list-wrapper">
              <ul className="link-list">
                  {lista}
              </ul>
          </div>
      </div>
    );
}

export default NavbarDropdown;
